import { useCallback, useReducer } from "react";

const tabReducer = (state, action) => {
  const { type } = action;
  const { payload } = action;

  //  console.log("tabReducer? "+JSON.stringify(state)+"; action="+ type)
  let tabId = payload.tabId;
  if (tabId === undefined) tabId = payload.path;

  // to navigate to the page / tab
  const navigateToClickedTab = () => {
    console.log("navigateToClickedTab? " + tabId);
    return {
      ...state,
      currentTab: tabId,
    };
  };

  switch (type.toUpperCase()) {
    case "ADD": {
      console.log(state.storedTabs);
      if (
        state.storedTabs.some((tab) => {
          return tab.tabId === tabId;
        })
      ) {
        return navigateToClickedTab();
      }
      console.log("state.newtab");

      return {
        ...state,
        currentTab: tabId,
        storedTabs: [...state.storedTabs, payload],
      };
    }

    case "BACK": {
      if (
        state.storedTabs.some((tab) => {
          return tab.tabId === tabId;
        })
      ) {
        return navigateToClickedTab();
      }
      return {
        ...state,
        currentTab: tabId,
        storedTabs: [...state.storedTabs, payload],
      };
    }

    case "REMOVE": {
      const index = state.storedTabs.findIndex((tab) => {
        return tab.tabId === tabId;
      });
      const newStoredTabs = state.storedTabs.filter((tab) => {
        return tab.tabId !== tabId;
      });
      let newCurrentTabPath;
      if (newStoredTabs.length === 0) {
        newCurrentTabPath = null;
      } else {
        if (newStoredTabs?.at(index)) {
          newCurrentTabPath = newStoredTabs?.at(index)?.tabId;
        } else {
          newCurrentTabPath = newStoredTabs?.at(index - 1)?.tabId;
        }
      }
      return {
        ...state,
        currentTab: newCurrentTabPath,
        storedTabs: newStoredTabs,
      };
    }
    case "UPDATE": {
      const theTabIndex = state.storedTabs.findIndex((tab) => {
        return tab.tabId === tabId;
      });
      if (theTabIndex >= 0) {
        state.storedTabs[theTabIndex].name = payload.name;
      }
      return { ...state };
    }
    case "NAVIGATE": {
      return navigateToClickedTab();
    }
    case "REMOVE_ALL": {
      return {
        currentTab: null,
        storedTabs: [],
      };
    }
    default: {
      throw new Error("[useTabs] dispatch has received non exist type.");
    }
  }
};

const useTabs = () => {
  const initialValue = {
    currentTab: JSON.parse(sessionStorage.getItem("currentTab")) || null,
    storedTabs: JSON.parse(sessionStorage.getItem("storedTabs")) || [],
  };
  const [state, dispatch] = useReducer(tabReducer, initialValue);
  const tabDispatch = useCallback((type, payload) => {
    return dispatch({ type, payload });
  }, []);
  return [state, tabDispatch];
};

export default useTabs;
